/* eslint-disable no-restricted-syntax */
import { mapActions, mapState } from 'vuex';
import loaderMixin from '@/mixins/loader';
import disqusMixin from '@/mixins/disqus';
import cmsContentMixin from '@/mixins/cmsContent';

export default {
  mixins: [
    cmsContentMixin,
    disqusMixin,
    loaderMixin,
  ],
  props: {
    storyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      pageComponent: null,
    };
  },
  metaInfo() {
    if (this.currentStoryDetail !== null) {
      return {
        title: this.currentStoryDetail.seoTitle,
      };
    }
    return {};
  },
  computed: {
    ...mapState('browse', ['currentStoryDetail']),
  },
  methods: {
    ...mapActions('browse', ['getStoryDetail', 'clearCurrentStoryDetail']),
  },
  mounted() {
    this.loaderAdd(document.body);
    this.getStoryDetail(this.storyId)
      .then(() => {
        this.loaderRemove(document.body);
        this.installDynamicControls({
          data: {
            ...this.currentStoryDetail,
          },
        });
      })
      .catch(() => this.loaderRemove(document.body));
  },
  beforeDestroy() {
    this.clearCurrentStoryDetail();
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-story-detail/page-story-detail.js